import React from 'react';
import moment from 'moment';
import CurrentReplenishmentStock from '../components/CurrentReplenishmentStock';
import StockIndicator from '../components/StockIndicator';
import LastStockUpdate from './LastStockUpdate';
import LastShippedReplenishments from './LastShippedReplenishments';
import ReplenishmentQuantity from './ReplenishmentQuantity';

export class ScheduledReplenishmentItem extends React.Component {

    constructor(props, context) {
        super(props, context);
        this.state = {
            replenishmentQuantity: 1
        };
        this.renderReplenishmentStock = this.renderReplenishmentStock.bind(this);
        this.handleQuantityChange = this.handleQuantityChange.bind(this);
        this.renderActions = this.renderActions.bind(this);
    }

    renderReplenishmentStock() {
        if (!this.props.replenishmentStockQuantity) {
            return '--'
        } else {
            return <CurrentReplenishmentStock
                        unlimitedStock={this.props.unlimitedStock}
                        actualStock={this.props.replenishmentStockQuantity}
                        reservedStock={this.props.pendingStockQuantity}
                        availableStock={this.props.availableStockQuantity}
            />
        }
    }

    handleQuantityChange(event) {
        this.setState({replenishmentQuantity: event.target.value});
    }

    renderActions() {
        if (this.props.status === 'open') {
            return (
                <div>
                    <button className="btn btn-sm btn-success"
                            onClick={() => this.props.releaseScheduledReplenishment(this.props.id, this.state.replenishmentQuantity)}
                            title="freigeben">
                        <i className="fa fa-truck"></i>
                    </button>
                    <button className="btn btn-sm btn-danger"
                            onClick={() => this.props.deleteScheduledReplenishment(this.props.id)}
                            title="löschen">
                        <i className="fa fa-trash"></i>
                    </button>
                </div>
            );
        }

        return null;
    }

    render() {

        const createdAt = moment.utc(this.props.createdAt).local();
        const createdAtDate = createdAt.format('DD.MM.YYYY');
        const createdAtTime = createdAt.format('HH:mm:ss');

        const pendingReplenishments = this.props.pendingReplenishments.map(pendingRepl => {return {createdAt: pendingRepl.createdAt, quantity: pendingRepl.quantity}});

        return (
            <tr>
                <td style={{verticalAlign: 'middle'}}>
                    <input name="selectItem" type="checkbox" checked={this.props.isSelected}
                           onChange={() => this.props.selectItem(this.props.id)}/>
                </td>
                <td>{this.props.id}</td>
                <td nowrap="nowrap">{createdAtDate} {createdAtTime}</td>
                <td style={{textAlign: 'right'}}><LastStockUpdate lastUpdatedAt={this.props.stockInStoreLastUpdatedAt}/></td>
                <td style={{textAlign: 'right', verticalAlign: 'top', fontSize: 'medium'}}>
                    <div style={{display: 'grid', gridTemplateColumns: 'repeat(5, 25px)', gridGap: '2px', gridAutoRows: '25px'}}>
                        <StockIndicator stockInStore={this.props.stockQuantityInStore}
                                        minimumStockQuantity={this.props.minimumStockQuantity}
                                        pendingReplenishments={pendingReplenishments} />
                    </div>
                </td>
                <td style={{textAlign: 'right'}}>{this.renderReplenishmentStock()}</td>
                <td style={{textAlign: 'right'}}><LastShippedReplenishments replenishments={this.props.recentlyShippedReplenishments} /></td>
                <td>{this.props.store.retailer.gln}<br/>{this.props.store.retailer.name}</td>
                <td>{this.props.store.gln}<br/>{this.props.store.zipCode}<br/>{this.props.store.city}</td>
                <td>{this.props.module.name}</td>
                <td>{this.props.article.brand}</td>
                <td>{this.props.article.erpIdno}<br/>{this.props.article.gtin}<br/>{this.props.article.name}</td>
                <td>{this.props.article.vendorArticleNumber}</td>
                <td><ReplenishmentQuantity value={this.state.replenishmentQuantity} max={5} onChange={this.handleQuantityChange}/></td>
                <td>{this.renderActions()}</td>
            </tr>
        )
    }
}

export default ScheduledReplenishmentItem;



// WEBPACK FOOTER //
// ./src/admin/scheduledreplenishment/ScheduledReplenishmentItem.js